export enum CandidateDeliveryDeadlineType {
  APPLICATION_COMPLETED = "APPLICATION_COMPLETED",
  EXTRA_TIME_REQUESTED = "EXTRA_TIME_REQUESTED",
  JOB_POST_REMAINING_TIME = "JOB_POST_REMAINING_TIME",
  SENT_TO_BEAUTIFICATION = "SENT_TO_BEAUTIFICATION"
}
export interface ICandidateDeliveryDeadline {
  expiresAt: string | Date;
  deliveredAt?: string | Date;
  type: string;
}

export class CandidateDeliveryDeadline {
  public expiresAt: string | Date;
  public deliveredAt?: string | Date;
  public type: string;

  constructor(data: ICandidateDeliveryDeadline) {
    this.expiresAt = data.expiresAt;
    this.deliveredAt = data.deliveredAt;
    this.type = data.type;
  }
}
